"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountProperties = void 0;
const ArticleProperties_1 = require("./ArticleProperties");
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Discount properties that are used by the individual applications.
 */
class DiscountProperties {
}
exports.DiscountProperties = DiscountProperties;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE;
DiscountProperties[_a] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
DiscountProperties[_b] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
//# sourceMappingURL=DiscountProperties.js.map